module.exports = __webpack_public_path__ + "static/media/Atlanta.e9e1a003.png";